module.exports = __webpack_public_path__ + "static/bought-together-276b6cd053194cb03d9dce4e27ad870f.jpg";